/* eslint-disable */
// because legacy

/*
    Outdoorish training graph
    -------------------------

    Displays a line chart with the training information of one week.


    Dependencies:
    -------------
        raphael.js (http://raphaeljs.com/)
        raphael-popup.js (taken from: http://raphaeljs.com/analytics.html)

 */

import Raphael from "raphael"
import { UNIT } from '@bikemap/js/settings'

$(function() {
  "use strict"

  $.outdoorish.graph = $.outdoorish.graph || {}

  /*
   * Creates a outdoorish training graph
   */
  $.outdoorish.graph.createGraph = function(config) {
    // Creates a Raphael path string from the given data array
    // eslint-disable-next-line max-params
    Raphael.fn.getPathString = function(
      data,
      graphHeight,
      topgutter,
      xStart,
      columnWidth,
      resolution
    ) {
      var path = ""

      var x = xStart

      var y

      var i

      for (i = 0; i < data.length; i++) {
        y = graphHeight - data[i] * resolution + topgutter

        if (i === 0) {
          path += "M" + [xStart, y] + "R"
        } else {
          x += columnWidth
          path += "," + [x, y]
        }
      }

      return path
    }

    // Draws a grid matching the configuration options
    // eslint-disable-next-line max-params
    Raphael.fn.drawGrid = function(x, y, width, height, data, rowCount, color) {
      var i

      color = color || "#000"

      // The bottom line of the grid
      var path = [
        "M",
        Math.round(x) + 0.5,
        Math.round(y + height) + 0.5,
        "L",
        Math.round(x + width) + 0.5,
        Math.round(y + height) + 0.5
      ]

      var rowHeight = height / rowCount

      var columnCount = data.length

      var columnWidth = width / columnCount

      // Draw row lines
      for (i = 1; i < rowCount; i++) {
        path = path.concat([
          "M",
          Math.round(x) + 0.5,
          Math.round(y + i * rowHeight) + 0.5,
          "H",
          Math.round(x + width) + 0.5
        ])
      }

      // Draw column lines
      for (i = 1; i < columnCount; i++) {
        path = path.concat([
          "M",
          Math.round(x + i * columnWidth) + 0.5,
          Math.round(y) + 0.5,
          "V",
          Math.round(y + height) + 0.5
        ])
      }

      return this.path(path.join(",")).attr({ stroke: color })
    }

    // Get configuration or set nice defaults.
    var data = config.data || []

    var labels = config.labels || []

    var infos = config.infos || []

    var containerId = config.container_id || "outdoorish-graph"

    var unit = UNIT || "metric"

    var width = config.width || 652

    var height = config.height || 200

    var leftgutter = config.leftgutter || 0

    var bottomgutter = config.bottomgutter || 20

    var topgutter = config.topgutter || 10

    var numLines = config.num_lines || 6

    // Calculate some useful values from the config

    var maxValue = Math.round((Math.max.apply(Math, data) + 5) / 10) * 10

    var xStart = leftgutter + (width - leftgutter) / data.length / 2

    var graphHeight = height - topgutter - bottomgutter

    var graphWidth = width - leftgutter

    var yStepSize = graphHeight / numLines

    var valueStepSize = maxValue / numLines

    var columnWidth = (width - leftgutter) / data.length

    var resolution = graphHeight / maxValue

    // Visual configuration

    var lineColor = "#1381fa"

    var txt = {
      fill: "#dfdfdf",
      font: "11px -apple-system, BlinkMacSystemFont, Roboto, sans-serif",
      "font-weight": "bold"
    }

    var txt1 = {
      fill: "#9b9b9b",
      font: "11px -apple-system, BlinkMacSystemFont, Roboto, sans-serif"
    }

    var txt2 = {
      fill: "#9b9b9b",
      font: "11px -apple-system, BlinkMacSystemFont, Roboto, sans-serif",
      "font-weight": "bold"
    }

    var popupAttrs = {
      fill: "#fff",
      "fill-opacity": 1,
      stroke: lineColor,
      "stroke-width": 2
    }

    var hidden = {
      fill: "#000",
      opacity: 0,
      stroke: "none"
    }

    // General variables

    var i

    // Raphael canvas object and path to draw on

    var r = new Raphael(containerId, width, height)

    var path = r.getPathString(
      data,
      graphHeight,
      topgutter,
      xStart,
      columnWidth,
      resolution
    )

    // MAIN

    // draw grid
    r.drawGrid(
      leftgutter + 0.5,
      topgutter + 0.5,
      graphWidth,
      graphHeight,
      data,
      numLines,
      "#e0e0e0"
    )

    // Draw labels for x axis
    for (i = 0; i < labels.length; i++) {
      r.text(xStart + i * (width / labels.length), height - 5, labels[i]).attr(
        txt
      )
    }

    // Draw labels for y axis
    for (i = 1; i <= numLines; i++) {
      var x1 = leftgutter + 10

      var y1 = topgutter + i * yStepSize - 5

      var val = 0

      // Calculate localized distance values
      if (unit === "metric") {
        val = Math.round(maxValue - i * valueStepSize)
      } else {
        val = Math.round((maxValue - i * valueStepSize) * 0.62)
      }
      r.text(x1, y1, val).attr(txt)
    }

    // Draw line
    r.path(path).attr({
      fill: "none",
      stroke: lineColor,
      "stroke-width": 4,
      "stroke-linecap": "round"
    })

    // Fill area below line
    var endpath = [
      width - xStart,
      height - bottomgutter + 1,
      leftgutter + xStart,
      height - bottomgutter + 1
    ]

    var bg

    var blanket

    var label

    var frame

    var mouseLeaveTimeout

    blanket = r.set()

    bg = r.path("M0,0").attr({ stroke: "none", opacity: 0.3 })
    bg.attr({ path: path + "L" + endpath.join(",") + "z", fill: lineColor })

    // Just for calculations of popup maximum dimensions
    label = r.set()
    label.push(r.text(10, 10, "153 km").attr(txt1))
    label.push(r.text(10, 25, "1235 hm").attr(txt1))
    label.push(r.text(10, 40, "00:00 h").attr(txt1))
    label.push(r.text(10, 55, "2. September 2012").attr(txt2))
    label.hide()

    frame = r
      .popup(10, 10, label, "right")
      .attr(popupAttrs)
      .hide()

    for (i = 0; i < data.length; i++) {
      // Draw area for hover
      blanket.push(
        r
          .rect(
            leftgutter + i * columnWidth + 10,
            0,
            columnWidth - 20,
            height - bottomgutter
          )
          .attr(hidden)
          .toFront()
      )
      var rect = blanket[blanket.length - 1]

      // Draw dot
      var y = graphHeight - data[i] * resolution + topgutter

      var x = xStart + (i * width) / data.length
      var dot = r
        .circle(x, y, 4)
        .attr({ fill: "#fff", stroke: lineColor, "stroke-width": 2 })

      // Create content for popup
      label = r.set()
      label.push(r.text(x, y, infos[i].distance).attr(txt1))
      label.push(r.text(x, y + 15, infos[i].altitude).attr(txt1))
      label.push(r.text(x, y + 30, infos[i].duration).attr(txt1))
      label.push(r.text(x, y + 45, infos[i].date).attr(txt2))
      label.hide()

      // Positioning of the popup
      var pos = "right"
      if (x + frame.getBBox().width > width) {
        pos = "left"
      }
      if (y - frame.getBBox().height < topgutter) {
        pos = "bottom"
      }
      if (y + frame.getBBox().height > height) {
        pos = "top"
      }

      // Create popup
      var popup = r
        .popup(x, y, label, pos)
        .attr(popupAttrs)
        .hide()

      // Handle mouse over
      ;(function(dot, rect, popup, label) {
        // Setup hover effect
        rect.hover(
          function() {
            // Mouse over
            clearTimeout(mouseLeaveTimeout)
            popup.show()
            label.show()
            dot.attr("r", 6)
          },
          function() {
            // Mouse out
            mouseLeaveTimeout = setTimeout(function() {
              label.hide()
              popup.hide()
              dot.attr("r", 4)
            }, 1)
          }
        )
      })(dot, rect, popup, label)
    }

    frame.toFront()
    label[0].toFront()
    label[1].toFront()
    label[2].toFront()
    label[3].toFront()
    blanket.toFront()
  }
})
